import React from 'react';
import { Box, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Sidebar from '@repo/shared/components/Sidebar';

/**
 * Standalone sidebar for anonymous Teams web client users.
 *
 * Opened as a popup window by the Polyguard SDK when it detects the user
 * has no active Microsoft session (no pg_msft_session cookie).
 * Authenticated users are never sent here — the SDK auto-redirects them.
 */
export default function StandaloneSidebar() {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation('teams');
  const linkUuid = searchParams.get('linkUuid');

  if (!linkUuid) {
    return (
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3 }}>
        <Typography color="error">{t('standaloneSidebar.missingLink')}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
      <Sidebar platform="ms-teams" linkUuid={linkUuid} />
    </Box>
  );
}
